// extracted by mini-css-extract-plugin
module.exports = {"full-screen-wrapper":"style_full-screen-wrapper__E9rwR","overlay":"style_overlay__Iz1lY","mobile-img":"style_mobile-img__QcPZd"};